import { genres, navLinks } from "@/mocks/comics";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2 font-heading text-xl">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-book-3-line text-lg" aria-hidden="true"></i>
              </span>
              香香漫画
            </a>
            <p className="mt-4 max-w-[420px] text-sm leading-relaxed text-background-100/80">
              一个把「最新更新」「完结全集」「免费阅读」整理在一起的漫画入口。我们关心的是让你少翻页、快找到、
              不断更，把时间留给真正想看的作品。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100">
                <i className="ri-refresh-line text-sm text-accent-300" aria-hidden="true"></i>
                每日整理更新
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100">
                <i className="ri-download-2-line text-sm text-accent-300" aria-hidden="true"></i>
                完结全集打包
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50">
              <a href="#latest" className="hover:text-accent-300 transition-colors">
                页面导航
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.target}>
                  <a
                    href={`#${link.target}`}
                    className="text-sm text-background-100/80 hover:text-accent-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50">
              <a href="#genres" className="hover:text-accent-300 transition-colors">
                热门题材
              </a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {genres.slice(0, 8).map((genre) => (
                <li key={genre.name}>
                  <a
                    href="#latest"
                    className="text-sm text-background-100/80 hover:text-accent-300 transition-colors"
                  >
                    {genre.name}漫画
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/70">
            © 2026 香香漫画 · 本站为漫画资讯与入口整理展示，作品版权归原作者及版权方所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#guide" className="text-xs text-background-100/80 hover:text-accent-300 transition-colors">
              阅读指南
            </a>
            <a href="#faq" className="text-xs text-background-100/80 hover:text-accent-300 transition-colors">
              常见问题
            </a>
            <a
              href="#top"
              className="inline-flex items-center gap-1 rounded-md bg-background-50/10 px-3 py-1.5 text-xs text-background-50 hover:bg-background-50/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-up-line text-sm" aria-hidden="true"></i>
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}